import { uuid } from "vue-uuid";

/* eslint-disable */
export default {
  data() {
    return {
      /** ONAYLA çift tıklama / touch yinelemesi ile onlarca satır eklenmesini önler */
      addToCartInFlight: false,
      productPlaceHolder: require("@/assets/images/products/product-kahve.png"),
      isExtraSelectionOpen: false,
      quantity: 1,
      rawMaterials: [],
      selectedRecipe: {},
      productName: [""],
      isVariantSelectionOpen: false,
      selectedRawMaterial: null,
      isRawMaterialsReload: true,
      selectedExtras: [],
    };
  },
  computed: {
    realSelectedExtras() {
      const returnObj = [];
      this.selectedExtras.filter((x) => {
        if (x.quantity > 0) {
          returnObj.push(x);
        } else if (x.variants != null && x.variants.length > 0) {
          if (x.variants.some((z) => z.quantity > 0)) {
            x.variants
              .filter((y) => y.quantity > 0)
              .forEach((variantExtra) => {
                returnObj.push(variantExtra);
              });
          }
        }
      });
      return returnObj.length > 0 ? returnObj : null;
    },
    currentCart() {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    toUpdateEntry() {
      return this.$store.getters["selfservice/getToUpdateEntry"];
    },
    selectedProduct() {
      return this.$store.getters["selfservice/getSelectedProduct"];
    },
    activeCart() {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    description() {
      if (this.selectedProduct == null) {
        if (!this.toUpdateEntry || !this.toUpdateEntry.rawProduct || !this.toUpdateEntry.rawProduct.children) return "";
        const selectedChild = this.toUpdateEntry.rawProduct.children.find((x) => x.isSelected);
        return selectedChild ? selectedChild.description || "" : "";
      }
      if (!this.selectedProduct || !this.selectedProduct.children) return "";
      const selectedChild = this.selectedProduct.children.find((x) => x.isSelected);
      return selectedChild ? selectedChild.description || "" : "";
    },
  },
  created() {
    if (!this.toUpdateEntry) {
      this.selectedRecipe = this.findSelectedProductInDeep(this.selectedProduct);
      this.selectedRecipe.image = this.selectedProduct.imageUrl;
    } else {
      this.selectedRecipe = this.findSelectedProductInDeep(this.toUpdateEntry.rawProduct);
      this.selectedRecipe.recipeSteps.forEach((step) => {
        step.isRemoved = this.toUpdateEntry.recipe.steps.find((x) => x.stepId === step.id).isRemoved;
        step.isRemovable = this.toUpdateEntry.recipe.steps.find((x) => x.stepId === step.id).isRemovable;
      });
      this.selectedRecipe.image = this.toUpdateEntry.rawProduct.imageUrl;
      this.quantity = this.toUpdateEntry.quantity;
      this.productId = this.toUpdateEntry.productId;
      this.childProductId = this.toUpdateEntry.childProductId;
      this.selectedExtras = this.toUpdateEntry.extras;
      this.setSelectedVariant();
    }
  },
  watch: {
    isVariantSelectionOpen(val) {
      if (!val) {
        this.selectedRawMaterial = null;
      }
    },
    toUpdateEntry: {
      handler(val) {
        if (!val || !this.toUpdateEntry || !this.toUpdateEntry.rawProduct) return;
        this.productName = [""];
        this.selectedRecipe = this.findSelectedProductInDeep(this.toUpdateEntry.rawProduct);
        this.selectedRecipe.recipeSteps.forEach((step) => {
          step.isRemoved = this.toUpdateEntry.recipe.steps.find((x) => x.stepId === step.id).isRemoved;
        });
        this.quantity = this.toUpdateEntry.quantity;
        this.productId = this.toUpdateEntry.productId;
        this.childProductId = this.toUpdateEntry.childProductId;
        this.selectedExtras = this.toUpdateEntry.extras;
        this.setSelectedVariant();
      },
      deep: true,
    },
  },
  methods: {
    removeRecipeStep(step) {
      step.isRemoved = !step.isRemoved;
    },
    toggleRecipeStep(recipeStep) {
      recipeStep.isRemoved = !recipeStep.isRemoved;
    },
    openRecipeReviewer() {
      this.$refs.recipeReviewer.recipe = this.selectedRecipe;
      this.$refs.recipeReviewer.isActive = true;
    },
    openDescription() {
      this.$refs.productDescription.isActive = true;
      this.$refs.productDescription.description = this.description;
      this.$refs.productDescription.image =
        this.selectedProduct && this.selectedProduct.imageUrl
          ? this.$baseUrl + "/" + this.selectedProduct.imageUrl
          : this.toUpdateEntry && this.toUpdateEntry.rawProduct.imageUrl
            ? this.$baseUrl + "/" + this.toUpdateEntry.rawProduct.imageUrl
            : this.productPlaceHolder;
    },
    setSelectedVariant() {
      this.toUpdateEntry.recipe.steps.forEach((step) => {
        const raw = this.selectedRecipe.recipeSteps.find((x) => x.rawMaterial.id == step.originRawMaterialId);
        if (raw) {
          const selectedVariant = raw.rawMaterial.variants.find((y) => y.id == step.id);
          selectedVariant.selected = true;
        }
      });
    },
    resetCartEntry() {
      this.selectedRecipe.recipeSteps.forEach((x) => {
        x.rawMaterial.variants.forEach((v) => {
          v.selected = false;
        });
      });
    },
    calculateUpdateCartEntry() {
      const tempEntry = {};
      tempEntry.categories = _.cloneDeep(this.toUpdateEntry.categories);
      tempEntry.id = this.toUpdateEntry.id;
      tempEntry.quantity = this.quantity;
      tempEntry.productId = this.toUpdateEntry.productId;
      tempEntry.productSize = this.toUpdateEntry.productSize;
      tempEntry.childProductId = this.toUpdateEntry.childProductId;
      tempEntry.extras = this.selectedExtras;
      tempEntry.productName = this.toUpdateEntry.productName;
      tempEntry.recipe = {
        id: this.selectedRecipe.id,
        steps: [],
      };
      this.selectedRecipe.recipeSteps.forEach((step) => {
        let tempVariant = null;
        if (
          step.rawMaterial != null &&
          step.rawMaterial.variants != null &&
          step.rawMaterial.variants.length > 0
        ) {
          tempVariant = this.getSelectedVariant(step.rawMaterial.variants);
          tempVariant.stepId = step.id;
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempEntry.recipe.steps.push(tempVariant);
        } else {
          tempVariant = step.rawMaterial;
          tempVariant.stepId = step.id;
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempEntry.recipe.steps.push(tempVariant);
        }
      });
      tempEntry.price = this.selectedRecipe.price;
      if (tempEntry.extras && tempEntry.extras.length > 0) {
        tempEntry.extras.forEach((extra) => {
          if (extra.variants != null && extra.variants.length > 0) {
            extra.variants.forEach((extraVariant) => {
              if (extraVariant.quantity > 0)
                tempEntry.price = tempEntry.price + extraVariant.price * extraVariant.quantity;
            });
          } else tempEntry.price = tempEntry.price + extra.quantity * extra.price;
        });
      }
      tempEntry.price = tempEntry.price * tempEntry.quantity;
      return tempEntry;
    },
    calculateCartEntry: async function () {
      const tempEntry = {};
      tempEntry.categories = _.cloneDeep(this.selectedProduct.categories);
      tempEntry.id = uuid.v1();
      tempEntry.quantity = this.quantity;
      tempEntry.productSize = this.selectedProduct.sizeId;
      tempEntry.productId = this.selectedProduct.id;
      tempEntry.childProductId = this.childProduct.id;
      tempEntry.extras = this.selectedExtras;
      tempEntry.productName = this.productName.join("->").slice(2);
      tempEntry.recipe = {
        id: this.selectedRecipe.id,
        steps: [],
      };
      this.selectedRecipe.recipeSteps.forEach((step) => {
        let tempVariant = null;
        if (
          step.rawMaterial != null &&
          step.rawMaterial.variants != null &&
          step.rawMaterial.variants.length > 0
        ) {
          tempVariant = step.rawMaterial.variants.find((x) => x.selected === true);
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempVariant.stepId = step.id;
          tempVariant.selected = true;
          tempEntry.recipe.steps.push(_.cloneDeep(tempVariant));
        } else {
          tempVariant = step.rawMaterial;
          tempVariant.isRemoved = step.isRemoved;
          tempVariant.isRemovable = step.isRemovable;
          tempVariant.stepId = step.id;
          tempEntry.recipe.steps.push(tempVariant);
        }
      });

      tempEntry.price = this.selectedRecipe.price;
      if (tempEntry.extras && tempEntry.extras.length > 0) {
        tempEntry.extras.forEach((extra) => {
          if (extra.variants != null && extra.variants.length > 0) {
            extra.variants.forEach((extraVariant) => {
              if (extraVariant.quantity > 0)
                tempEntry.price = tempEntry.price + extraVariant.price * extraVariant.quantity;
            });
          } else tempEntry.price = tempEntry.price + extra.quantity * extra.price;
        });
      }

      tempEntry.price = tempEntry.price * tempEntry.quantity;
      return tempEntry;
    },
    AddToCart: async function () {
      if (this.addToCartInFlight) return;
      this.addToCartInFlight = true;
      try {
        if (this.toUpdateEntry) {
          const item = this.calculateUpdateCartEntry();
          item.price = Math.round(item.price * 100) / 100;
          item.originPrice = item.price;
          item.rawProduct = _.cloneDeep(this.toUpdateEntry.rawProduct);
          const oldEntryIndex = this.currentCart.cartEntries.findIndex((x) => x.id == item.id);
          const updateObj = {
            index: oldEntryIndex,
            entry: item,
          };
          this.resetCartEntry();
          this.$store.dispatch("selfservice/updateToCart", updateObj);
        } else {
          const item = await this.calculateCartEntry();
          item.price = Math.round(item.price * 100) / 100;
          item.originPrice = item.price;
          item.rawProduct = _.cloneDeep(this.selectedProduct);
          this.$store.dispatch("selfservice/addToCart", item);
          this.$store.dispatch("selfservice/setSelectedProduct", null);
          this.$store.dispatch("selfservice/setPreSelectedProduct", null);
          this.resetCartEntry();
        }
      } finally {
        const release = () => {
          if (!this._isDestroyed) this.addToCartInFlight = false;
        };
        if (typeof window !== "undefined") {
          window.setTimeout(release, 400);
        } else {
          this.$nextTick(release);
        }
      }
    },
    GoToProductSelectPage() {
      if (this.toUpdateEntry) {
        this.resetCartEntry();
        this.$store.dispatch("selfservice/setToUpdateEntry", null);
      } else this.$store.dispatch("selfservice/setSelectedProduct", null);
    },
    getSelectedVariant(variants) {
      let selectedItem = variants.find((x) => x.selected == true);
      if (selectedItem == null) {
        variants.forEach((item) => {
          if (item.isDefault == true) {
            item.selected = true;
            selectedItem = item;
          } else {
            item.selected = false;
          }
        });
      }
      return _.cloneDeep(selectedItem);
    },
    findSelectedProductInDeep(rawProduct) {
      const product = _.cloneDeep(rawProduct);
      this.productName.push(product.name);
      if (product.children == null && product.isSelected) {
        product.recipe.price = product.price;
        this.childProduct = product;
        return product.recipe;
      }
      if (product.children != null) {
        const selectedChildren = product.children.find((x) => x.isSelected);
        return this.findSelectedProductInDeep(selectedChildren);
      }
    },
    updateVariant(rawMaterial) {
      if (rawMaterial.variants != null && rawMaterial.variants.length > 0) {
        this.selectedRawMaterial = rawMaterial;
        this.isVariantSelectionOpen = true;
      }
    },
    closeVariantSelection() {
      this.isVariantSelectionOpen = false;
      this.selectedRawMaterial = null;
    },
    variantSelection(variant) {
      this.isRawMaterialsReload = false;

      this.selectedRawMaterial.variants.forEach((item) => {
        if (variant.id === item.id) {
          item.selected = true;
        } else {
          item.selected = false;
        }
      });
      this.selectedRecipe.recipeSteps
        .find((x) => x.rawMaterial.id == this.selectedRawMaterial.id)
        .rawMaterial.variants.find((y) => y.id == variant.id).selected = true;

      this.isVariantSelectionOpen = false;
      this.selectedRawMaterial = null;

      this.$nextTick(() => {
        this.isRawMaterialsReload = true;
      });
    },
    openExtraSelection() {
      this.isExtraSelectionOpen = true;
    },
    saveExtraSelection(selectedExtras) {
      this.selectedExtras = selectedExtras;
      this.isExtraSelectionOpen = false;
    },
    cancelExtraSelection() {
      this.isExtraSelectionOpen = false;
    },
  },
};
